import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
// import * as fuzzysearch from 'fuzzysearch';

@Component({
  selector: 'api-block-settings',
  templateUrl: './api-block-advanced-settings.component.html',
  styleUrls: ['./api-block-advanced-settings.component.scss']
})
export class ApiBlockAdvancedSettingsComponent implements OnInit {
  @Input() headersData: any;
  headers = ['keyValue', 'valueValue'];
  @Input() headersValueList = [
    {
      blockType: 'text',
      match: 'pkey',
      value: '234234234234'
    },
    {
      blockType: 'text',
      match: 'admimpkey',
      value: 'f4rf4rf4rcv4v'
    },
    {
      blockType: 'text',
      match: 'apikey',
      value: '23424rf4rf4rf4rf34234234'
    },
    {
      blockType: 'text',
      match: 'dfdapikey',
      value: 'sde43rf4rf4rf'
    }
  ];


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ApiBlockAdvancedSettingsComponent>) {
    if (data.headersData) {
      this.headersData = data.headersData;
      this.headersValueList = data.headersvalueList;
    } else {
      this.headersData = [];
    }
  }

  ngOnInit() {
  }

  addHeader() {
    this.headersData.push({
      keyType: 'text',
      keyValue: '',
      valueType: 'text',
      valueValue: ''
    });
  }

  getHeadersRegex(headerKey) {
    // if (headerKey) {
    //   const filteredList = this.headersValueList.filter(object => fuzzysearch(headerKey, object.match));
    //   return filteredList;
    // }
    return [];
  }

  removeHeader(index) {
    if (confirm('Are you sure you want to remove this attribute?')) {
      this.headersData.splice(index, 1);
    }
  }

  getParamWidth(val) {
    return Math.floor(100 / (val.length)).toString() + '%';
  }

}
